/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { LoadMoreStoriesBase, Collection } from "@quintype/components";

import { AdService } from "../../ad-service";
import get from "lodash/get";
import { isEmpty, updateStoriesWithAlternatives, collectionWithIntroductionCard } from "../../../utils";
import PropTypes from "prop-types";
import { AuthorDetails, AuthorMainStories, AuthorStories } from "./author-utils";
import { getCollectionTemplate } from "../../get-collection-template";
import "./author-page.module.css";

const apiResponseTransformer = response => response.items;

const AuthorPage = props => {
  const updatedStoriesWithAlternatives = updateStoriesWithAlternatives(props.data.stories);

  const fields =
    "alternative,metadata,story-template,id,hero-image-s3-key,hero-image-metadata,headline,published-at,slug,url";
  const authorId = get(props, ["data", "author", "id"]);
  const numStoriesToLoad = 20;
  const authorDetails = get(props, ["data", "author"], {});
  const collection = collectionWithIntroductionCard(
    props.config,
    updatedStoriesWithAlternatives,
    "author",
    authorDetails
  );
  const pbLayout = get(props.config, ["pagebuilder-config", "author", "rows"], []);

  AuthorPage.propTypes = {
    config: PropTypes.object
  };

  const AuthorPageCollectionLayout = () => {
    return <Collection config={props.config} collection={collection} collectionTemplates={getCollectionTemplate} />;
  };

  const AuthorPageStoryLayout = ({ props }) => {
    return (
      <div>
        {!isEmpty(props.data) ? (
          <div styleName="author-detail-page">
            <AuthorDetails author={props.data.author} />
            <section styleName="author-page-dfp">
              <AdService adtype="Mrec" slotId="Author-Mrec" />
            </section>
            {get(props.data, ["stories"], []).length ? (
              <React.Fragment>
                <AuthorMainStories stories={updatedStoriesWithAlternatives.slice(0, 3)} />
                <LoadMoreStoriesBase
                  api={`/api/v1/authors/${authorId}/collection`}
                  template={AuthorStories}
                  apiResponseTransformer={apiResponseTransformer}
                  fields={fields}
                  {...props}
                  params={{ "author-id": authorId, sort: "published-at" }}
                  numStoriesToLoad={numStoriesToLoad}
                />
              </React.Fragment>
            ) : (
              <h1>No stories found for this author</h1>
            )}
          </div>
        ) : (
          <div styleName="author-detail-page">
            <h1>Author not found</h1>
          </div>
        )}
      </div>
    );
  };

  return <>{pbLayout.length > 0 ? <AuthorPageCollectionLayout /> : <AuthorPageStoryLayout props={props} />}</>;
};

AuthorPage.propTypes = {
  data: PropTypes.object,
  props: PropTypes.object
};

export { AuthorPage };
